<template lang="pug">
    app-dialog(v-model="$_show" header="Вход для участников" width="378")
      .home__login
        app-text-field(v-model="password" label="Пароль" :errorText="error"  type="password"  @change="resetError" @keyup.enter="login")

      .text-right(slot="footer")
        app-button-action.mr-0(@click="login") Войти

</template>

<script>
import { userService } from '@/_services'
import { AppDialogToggable } from '@/components'
import Meeting from '@/common/Meeting'

export default {
  mixins: [AppDialogToggable, Meeting],
  name: 'oneLogin',
  data() {
    return {
      password: '',
      error: null,
    }
  },
  created() {
    this.password = ''
  },
  methods: {
    login () {
      let { password } = this

      userService.oneLogin(password).then(data => {
        if (data) {
          let fio = data.fio.replace(/"/gi, '')
          this.$_meeting_setCookieForUser(data.uid, fio)
          location.href = this.$_meeting_makeUrlForRoom(data.room)
        } else {
          this.error = 'Неправильно введен код доступа или срок его действия истек'
        }
      })
    },
    
    resetError () {
      this.error = null
    }
  },
}
</script>


